import { carouselItems } from '@/mocks/homeData';

export default function Carousel() {
  return (
    <section id="carousel" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6">
          焦点专题
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href="#media"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#media');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group block bg-background-50 rounded-xl overflow-hidden hover:ring-2 hover:ring-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}